/**
 * O motor de física (Rapier), carregado sob demanda.
 *
 * O pacote embute o WebAssembly em base64 (~1,1 MB comprimido). Em import
 * estático isso entraria no pacote inicial e todo aluno pagaria por ele só para
 * abrir a mesa; num import dinâmico o Vite separa o pedaço e só paga quem liga
 * a simulação. Se o carregamento falhar, a cena continua pelo desenho, sem
 * física (`indisponivel`).
 */
type ModuloRapier = typeof import('@dimforge/rapier3d-compat')

/**
 * O que as simulações usam do motor. Só estas peças: assim tanto o módulo do
 * import dinâmico quanto o import padrão dos testes servem.
 */
export type Rapier = Pick<ModuloRapier, 'World' | 'RigidBodyDesc' | 'ColliderDesc' | 'CoefficientCombineRule'>

export type EstadoMotor = 'ocioso' | 'carregando' | 'pronto' | 'indisponivel'

let motor: Promise<ModuloRapier> | null = null

/** Carrega o motor uma única vez por sessão. Uma falha não envenena as tentativas seguintes. */
export function carregarMotor(): Promise<ModuloRapier> {
  if (!motor) {
    motor = import('@dimforge/rapier3d-compat').then(async (modulo) => {
      await modulo.init()
      return modulo
    })
    motor.catch(() => {
      motor = null
    })
  }
  return motor
}
